<div class="d-flex" [formGroup]="formDate">
  <div class="tb-padding--right pr-3">
    <div class="form-group">
      <span class="mr-4 filter-title">{{titleStart || 'Từ ngày'}} 
        <span *ngIf="isRequired" style="color: red;">(*)</span>
      </span>
      <div class="d-flex align-items-center">
        <div id="start-date" class="input-group d-flex flex-column ">
          <div class="input-group">
            <input-date formControlName="startDate"  [isNoFuture]="isNoFuture"
              placeholder="Ngày bắt đầu" [isNoInput]="true">
            </input-date>
          </div>
        </div>
      </div>

      <div class="d-flex">
        <span *ngIf="isRequired && isValidated && !formDate.value.startDate" style="color: red;">Dữ liệu bắt buộc nhập</span>
      </div>

    </div>
  </div>
  <div class="tb-padding--right pr-3">
    <div class="form-group">
      <span class="mr-3 filter-title">{{titleEnd || 'Đến ngày'}}
        <span *ngIf="isRequired" style="color: red;">(*)</span>
      </span>
      <div class="d-flex align-items-center" >
        <div id="end-date" class="input-group d-flex flex-column">
          <div class="input-group">
            <input-date formControlName="endDate" [isNoFuture]="isNoFuture"
              placeholder="Ngày kết thúc" [isNoInput]="true">
            </input-date>
          </div>
        </div>
      </div>
      <div class="d-flex">
        <span *ngIf="isRequired && isValidated && !formDate.value.endDate" style="color: red;">Dữ liệu bắt buộc nhập</span>
      </div>
    </div>
  </div>
</div>